import { useTranslation } from 'next-i18next';
import ICalendarLink from 'react-icalendar-link';
import { AgendaEntry } from '../../../../../../interfaces/pagebuilder';
import { useMobileApp } from '../../../../../../hooks/useMobileApp';

interface EntryCalendarExportProps {
  entry: AgendaEntry;
  date: Date;
}

const EntryCalendarExport = (props: EntryCalendarExportProps) => {
  const { entry, date } = props;

  const { t } = useTranslation();
  const { isAppView } = useMobileApp();

  const exportEntry = {
    title: entry.title,
    description: entry.description,
    startTime: date,
  };

  if (isAppView()) {
    return (
      <p
        onClick={() => {
          (window as any).ReactNativeWebView.postMessage(JSON.stringify({ ...exportEntry, messageType: 'calendarexport' }));
        }}>
        ► {t('pagebuilder:export-to-calendar')}
      </p>
    );
  }

  return (
    //@ts-ignore
    <ICalendarLink event={{ ...exportEntry, startTime: date.toString() }} filename={`${entry.title}.ics`}>
      <p className="cursor-pointer link">► {t('pagebuilder:export-to-calendar')}</p>
    </ICalendarLink>
  );
};

export default EntryCalendarExport;
